<template>
    <div class="-userprofile-info -userprofile-info__wrap"
        :data-component-name="$options.name"
    >
        <q-btn class="-button-close" icon="close" size="xs"
            @click="$emit('hide-proxy')"
        >
        </q-btn>
        <h3 class="avatar-row">
            <UserAvatar
                :name="userProfile.name"
                :email="userProfile.email"
                :color="userProfile.type && userProfile.type.color ? userProfile.type.color : null"
                class="q-mr-sm"
            />
            <div>
                <div>
                    {{ userProfile.name }}
                </div>
                <div class="-title"
                    v-if="userProfile.title && userProfile.title!=''"
                >
                    {{ userProfile.title }}
                </div>
            </div>
        </h3>
        <div class="-row-info">

            <!-- <div class="-col-info"
                v-if="userProfile.title && userProfile.title!=''"
            >
                <q-icon name="person" class="q-mr-xs" />
                {{ userProfile.title }}
            </div> -->
<!-- {{ userProfile.__typename }} -->
            <div class="-col-info q-mb-md q-mt-sm text-red text-bold  align-items-center"
                v-if="typeof userProfile.is_active !== 'undefined' && !userProfile.is_active"
            >
                <q-icon name="warning" class="q-mr-xs" size="16px" />
                <span class="q-mt-xs q-ml-xs">Compte inactif</span>
            </div>
            <div class="-col-info q-mb-md"
                v-if="typeof userProfile.is_active !== 'undefined' && !userProfile.is_active"
            >
            </div>
            <div class="-col-info q-mb-sm"
                v-if="userProfile.email && userProfile.email!=''"
            >
                <q-icon name="mail" class="q-mr-xs" />
                <a :href="'mailto:'+userProfile.email">{{ userProfile.email }}</a>
            </div>
            <div class="-col-info q-mb-sm" style="align-items: baseline;"
                v-if="userProfile.secondary_email && userProfile.secondary_email!=''"
            >
                <q-icon name="mail" class="q-mr-xs" />
                <div>
                <a :href="'mailto:'+userProfile.secondary_email">{{ userProfile.secondary_email }}</a>
                <div class="text-muted" style="font-size: 9px;">(courriel secondaire)</div>
                </div>
            </div>

            <div class="-col-info"
                v-if="userProfile.website && userProfile.website!=''"
            >
                <q-icon name="language" class="q-mr-xs" />
                <a :href="userProfile.website" target="_blank">{{ userProfile.website }}</a>
            </div>

            <div class="-col-info"
                v-if="userProfile.phone_work && userProfile.phone_work!=''"
            >
                <q-icon name="business" class="q-mr-xs" />
                <a :href="'tel:'+userProfile.phone_work">{{ userProfile.phone_work }}</a>
            </div>

            <div class="-col-info"
                v-if="userProfile.phone_mobile && userProfile.phone_mobile!=''"
            >
                <q-icon name="phone_iphone" class="q-mr-xs" />
                <a :href="'tel:'+userProfile.phone_mobile">{{ userProfile.phone_mobile }}</a>
            </div>

            <div class="-col-info"
                v-if="userProfile.phone_home && userProfile.phone_home!=''"
            >
                <q-icon name="home" class="q-mr-xs" />
                <a :href="'tel:'+userProfile.phone_home">{{ userProfile.phone_home }}</a>
            </div>

            <div class="-col-info"
                v-if="userProfile.primary_phone && userProfile.primary_phone!=''"
            >
                <q-icon name="business" class="q-mr-xs" />
                <a :href="'tel:'+userProfile.primary_phone">{{ userProfile.primary_phone }}</a>
            </div>

            <div class="-col-info"
                v-if="userProfile.secondary_phone && userProfile.secondary_phone!=''"
            >
                <q-icon name="business" class="q-mr-xs" />
                <a :href="'tel:'+userProfile.secondary_phone">{{ userProfile.secondary_phone }}</a>
            </div>
            
            <div class="-col-info"
                v-if="userProfile.fax && userProfile.fax!=''"
            >
                <q-icon name="print" class="q-mr-xs" />
                <a :href="'tel:'+userProfile.fax">{{ userProfile.fax }}</a>
            </div>
            
            <div class="-col-info q-mt-sm"
                v-if="userProfile.url1 && userProfile.url1!=''"
            >
                <q-icon name="language" class="q-mr-xs" />
                <a :href="userProfile.url1" target="_blank">{{ userProfile.url1 }}</a>
            </div>

            <div class="-col-info"
                v-if="userProfile.url2 && userProfile.url2!=''"
            >
                <q-icon name="language" class="q-mr-xs" />
                <a :href="userProfile.url2" target="_blank">{{ userProfile.url2 }}</a>
            </div>
            <div class="-col-info"
                v-if="userProfile.type && userProfile.type.name!=''"
            >
                {{ userProfile.type.name }}
            </div>
            <div class="-col-info"
                v-if="userProfile.description && userProfile.description!=''"
            >
                {{ userProfile.description }}
            </div>

            <div class="-col-info full-width q-mt-sm">
            </div>

            <div class="-col-info"
                v-if="(userProfile.street && userProfile.street!='')
                        || (userProfile.town && userProfile.town!='')
                        || (userProfile.state && userProfile.state!='')
                        || (userProfile.country && userProfile.country!='')
                        || (userProfile.zipcode && userProfile.zipcode!='')
                        ">
                <div class="-col">
                    <q-icon name="place" class="q-mr-xs" />
                </div>
                <div class="-col">
                    <div class="text-no-wrap" v-if="userProfile.street && userProfile.street">
                        {{ userProfile.street && userProfile.street }}
                    </div>
                    <div class="text-no-wrap" v-if="(userProfile.town && userProfile.town!='') || (userProfile.state && userProfile.state!='')">
                        <span v-if="userProfile.town && userProfile.town!=''">
                            {{ userProfile.town && userProfile.town }}
                        </span>
                        <span v-if="userProfile.state && userProfile.state!=''">
                            {{ userProfile.state && userProfile.state }}
                        </span>
                    </div>
                    <div class="text-no-wrap" v-if="(userProfile.zipcode && userProfile.zipcode!='') || (userProfile.country && userProfile.country!='')">
                        <span class="q-mr-sm" v-if="userProfile.zipcode && userProfile.zipcode!=''">
                            {{ userProfile.zipcode && userProfile.zipcode }}
                        </span>
                        <span v-if="userProfile.country && userProfile.country!=''">
                            {{ userProfile.country && userProfile.country }}
                        </span>
                    </div>
                </div>
            </div>


            <div class="-col-info"
                v-if="companyInfo"
            >
                <div class="-col">
                    <q-icon name="business" class="q-mr-xs" />
                </div>
                <div class="-col">
                    <div class="text-no-wrap">
                        <strong>{{ companyInfo.name }}</strong>
                        <UserProfileInfo :userProfile="companyInfo" class="q-ml-sm" :size="'16px'" />
                    </div>
                    <div class="text-no-wrap" v-if="companyInfo.street && companyInfo.street">
                        {{ companyInfo.street && companyInfo.street }}
                    </div>
                    <div class="text-no-wrap" v-if="(companyInfo.town && companyInfo.town!='') || (companyInfo.state && companyInfo.state!='')">
                        <span v-if="companyInfo.town && companyInfo.town!=''">
                            {{ companyInfo.town && companyInfo.town }}
                        </span>
                        <span v-if="companyInfo.state && companyInfo.state!=''">
                            {{ companyInfo.state && companyInfo.state }}
                        </span>
                    </div>
                    <div class="text-no-wrap" v-if="(companyInfo.zipcode && companyInfo.zipcode!='') || (companyInfo.country && companyInfo.country!='')">
                        <span class="q-mr-sm" v-if="companyInfo.zipcode && companyInfo.zipcode!=''">
                            {{ companyInfo.zipcode && companyInfo.zipcode }}
                        </span>
                        <span v-if="companyInfo.country && companyInfo.country!=''">
                            {{ companyInfo.country && companyInfo.country }}
                        </span>
                    </div>
                </div>
            </div>


            <!-- <div class="-col-info full-width q-mt-sm"
                v-if="userProfile.vehicule_available
                    && userProfile.vehicules
                    && userProfile.vehicules.length>0">
            </div> -->


            <!-- <div class="-col-info" v-if="userProfile.vehicule_available && userProfile.vehicules && userProfile.vehicules.length>0">
                <div class="-col">
                    <q-icon name="directions_car" class="q-mr-xs" />
                </div>
                <div class="-col">
                    <div :key="vi" v-for="(vehicule, vi) in userProfile.vehicules">
                        {{ vehicule.name }}
                    </div>
                </div>
            </div> -->

        </div>



        <div class="c-extra-info"
            v-if="(myProfile && myProfile.role && (myProfile.role=='ADMINISTRATOR' || myProfile.role=='MANAGER') && (userProfile.__typename=='UserProfile' || userProfile.__typename == 'Resource'))
                    || (userProfile.__typename=='Customer')
                    || (userProfile.__typename=='CustomerContact')"
        >
        <!-- {{userProfile.contacts}} -->
            <q-tabs
                v-model="tab"
                dense
                class="text-grey c-extra-info__tabs"
                active-color="primary"
                indicator-color="primary"
                align="justify"
                narrow-indicator
                no-caps
                ref="jsTabs"
            >
                <q-tab name="profile" label="Profile" v-if="userProfile.__typename=='UserProfile'"/>
                <q-tab name="schedule" label="Horaire" v-if="userProfile.__typename=='UserProfile' || userProfile.__typename=='Resource'"/>
                <q-tab name="pending" label="Affectations en attente" v-if="userProfile.__typename=='UserProfile'"/>
                <q-tab name="contacts" label="Contacts" v-if="userProfile.__typename=='Customer' && userProfile.contacts && userProfile.contacts.data.length>0"/>
                <q-tab name="notes" label="Notes" v-if="(userProfile.__typename=='Customer' || userProfile.__typename=='CustomerContact') && userProfile.note && userProfile.note.trim()!=''"/>
                <q-tab name="internal_notes" label="Notes internes" v-if="(userProfile.__typename == 'UserProfile' || userProfile.__typename =='Customer') && userProfile.internal_notes && userProfile.internal_notes.trim()!=''"/>
            </q-tabs>


            <q-separator />
            <q-tab-panels v-model="tab" animated class="c-extra-info__content">

                <q-tab-panel name="profile" v-if="userProfile.__typename=='UserProfile'">

                    <div class="-row-info">
                        <div class="-col-info"
                            v-if="userProfile.professions && userProfile.professions.length>0"
                        >
                            <div class="">
                                <div class="-label" v-if="userProfile.professions.length==1">
                                    Métier
                                </div>
                                <div class="-label" v-if="userProfile.professions.length>1">
                                    Métiers
                                </div>
                                <div class="-value -row q-mb-sm"
                                    :key="tag.id"
                                    v-for="(tag) in userProfile.professions"
                                >
                                    <!-- <span class="u-text-truncate" :title="tag.name"> -->
                                    <span :title="tag.name">
                                        <span>{{ tag.name }}</span>
                                        <span v-if="tag.shortname && tag.shortname!=''" class="q-ml-xs" :title="tag.shortname">
                                            ({{tag.shortname}})
                                        </span>
                                    </span>
                                    <span class="-rating">
                                        <q-rating
                                            :value="tag.pivot.rating/20"
                                            size="0.8rem"
                                            :max="5"
                                            color-selected="green"
                                            color="grey"
                                            icon-half="circle_half"
                                            icon="circle_border"
                                            icon-selected="circle"
                                            readonly
                                        />
                                    </span>

                                </div>
                            </div>
                        </div>
                        <div class="-col-info"
                            v-if="userProfile.courses && userProfile.courses.length>0"
                        >
                            <div class="">
                                <div class="-label" v-if="userProfile.courses.length==1">
                                    Formation
                                </div>
                                <div class="-label" v-if="userProfile.courses.length>1">
                                    Formations
                                </div>
                                <div class="-value -row q-mb-sm"
                                    :key="ci"
                                    v-for="(tag, ci) in userProfile.courses"
                                >
                                    <!-- <span class="u-text-truncate" :title="tag.name">{{ tag.name }}</span> -->
                                    <span :title="tag.name">{{ tag.name }}</span>
                                    <span class="-rating">
                                        <q-rating
                                            :value="tag.pivot.rating/20"
                                            size="0.8rem"
                                            :max="5"
                                            color-selected="green"
                                            color="grey"
                                            icon-half="circle_half"
                                            icon="circle_border"
                                            icon-selected="circle"
                                            readonly
                                        />
                                    </span>

                                </div>
                            </div>
                        </div>
                        <div class="-col-info"
                            v-if="userProfile.skills && userProfile.skills.length>0"
                        >
                            <div class="">
                                <div class="-label" v-if="userProfile.skills.length==1">
                                    Compétence
                                </div>
                                <div class="-label" v-if="userProfile.skills.length>1">
                                    Compétences
                                </div>
                                <div class="-value -row q-mb-sm"
                                    :key="si"
                                    v-for="(tag, si) in userProfile.skills"
                                >
                                    <!-- <span class="u-text-truncate" :title="tag.name">{{ tag.name }}</span> -->
                                    <span :title="tag.name">{{ tag.name }}</span>
                                    <span class="-rating">
                                        <q-rating
                                            :value="tag.pivot.rating/20"
                                            size="0.8rem"
                                            :max="5"
                                            color-selected="green"
                                            color="grey"
                                            icon-half="circle_half"
                                            icon="circle_border"
                                            icon-selected="circle"
                                            readonly
                                        />
                                    </span>

                                </div>
                            </div>
                        </div>

                        <div class="-col-info" v-if="userProfile.role">
                            <div>
                                <div class="-label">
                                    Role
                                </div>
                                <div class="-value">
                                    {{ userProfile.role.charAt(0).toUpperCase() + userProfile.role.slice(1).toLowerCase() }}
                                </div>
                            </div>
                        </div>

                        <div class="-col-info"
                             v-if="userProfile.vehicule_available && userProfile.vehicules && userProfile.vehicules.length>0"
                        >
                            <div>
                                <div class="-label">
                                    Véhicule disponible
                                </div>
                                <div class="-value q-mb-sm"
                                    :key="vi"
                                    v-for="(vehicule, vi) in userProfile.vehicules"
                                >
                                    {{ vehicule.name }}
                                </div>
                            </div>
                        </div>
                        <div class="-col-info"
                             v-if="userProfile.distance"
                        >
                            <div>
                                <div class="-label">
                                    Distance du bureau
                                </div>
                                <div class="-value">
                                    {{ userProfile.distance }} km
                                    <span v-if="userProfile.distance_orientation">
                                        , {{userProfile.distance_orientation}}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                </q-tab-panel>



                <q-tab-panel name="schedule" class="fixed-height" v-if="userProfile.__typename=='UserProfile' || userProfile.__typename == 'Resource'">
                    <ScheduleList
                        v-if="userProfile.__typename == 'UserProfile'"
                        class="c-scheduleV2"
                        :currentDate="myDate"
                        :userProfileID="userProfile.id"
                        :scheduleScrollTo="scheduleScrollTo"
                        @set-current-date="myDate=$event"
                        @schedule-loaded="$emit('update-proxy')"
                        :relativePosition="true"
                        :showDrafts="myProfile.role=='ADMINISTRATOR'"
                    />
                    <ResourceScheduleList
                        v-else-if="userProfile.__typename == 'Resource'"
                        class="c-scheduleV2"
                        :currentDate="myDate"
                        :resourceID="userProfile.id"
                        :scheduleScrollTo="scheduleScrollTo"
                        @set-current-date="myDate=$event"
                        @schedule-loaded="$emit('update-proxy')"
                        :relativePosition="true"
                        :showDrafts="myProfile.role=='ADMINISTRATOR'"
                    />
                </q-tab-panel>


                <q-tab-panel name="pending" class="is-mobile fixed-height" v-if="userProfile.__typename=='UserProfile'">
                    <div class="inbox__wrap">
                        <div class="c-inbox-content">
                            <Pending
                                :isMobile="true"
                                :userProfile="userProfile"
                                @schedule-loaded="$emit('update-proxy')"
                                :relativePosition="true"
                            />
                        </div>
                    </div>
                </q-tab-panel>


                <q-tab-panel name="contacts" v-if="userProfile.__typename=='Customer' && userProfile.contacts && userProfile.contacts.data.length>0">
                    <div class="-row-info">
                        <div
                            :key="upci"
                            v-for="(contact, upci) in userProfile.contacts.data"
                            class="-col-info"
                        >
                            <!-- <div class="-col-info"> -->
                                <div class="-value -row">
                                    {{ contact.name }}
                                    <UserProfileInfo :userProfile="contact" class="q-ml-sm" :size="'16px'" />
                                </div>
                                <div class="-label" v-if="contact.email && contact.email.trim() != ''">
                                    <q-icon name="mail" class="q-mr-xs" />
                                    <a :href="'mailto:'+contact.email">{{ contact.email }}</a>
                                </div>
                                <div class="-label" v-if="contact.primary_phone && contact.primary_phone.trim()!=''">
                                    <q-icon name="phone" class="q-mr-xs" />
                                    <a :href="'tel:'+contact.primary_phone">{{ contact.primary_phone }}</a>
                                </div>
                                <div class="-label" v-if="contact.secondary_phone && contact.secondary_phone.trim()!=''">
                                    <q-icon name="phone" class="q-mr-xs" />
                                    <a :href="'tel:'+contact.secondary_phone">{{ contact.secondary_phone }}</a>
                                </div>
                                <div class="-label" v-if="contact.note && contact.note.trim()!=''">
                                    <q-icon name="text_snippet" class="q-mr-xs" />
                                    {{ contact.note }}
                                </div>
                            <!-- </div> -->
                        </div>
                    </div>
                </q-tab-panel>

                <q-tab-panel name="notes" v-if="(userProfile.__typename=='Customer' || userProfile.__typename=='CustomerContact') && userProfile.note && userProfile.note.trim()!=''">
                    
                    <div class="-row-info">
                        <div class="-col-info">
                            <div class="-value" v-html="$nl2br(userProfile.note)">
                                <!-- {{ userProfile.note }} -->
                            </div>
                        </div>
                    </div>
                </q-tab-panel>
                <q-tab-panel name="internal_notes" v-if="(userProfile.__typename == 'Customer' || userProfile.__typename =='UserProfile') && userProfile.internal_notes && userProfile.internal_notes.trim()!=''">
                    
                    <div class="-row-info">
                        <div class="-col-info">
                            <div class="-value" v-html="$nl2br(userProfile.internal_notes)">
                                <!-- {{ userProfile.note }} -->
                            </div>
                        </div>
                    </div>
                </q-tab-panel>

            </q-tab-panels>
        </div>
    </div>
</template>
<script>
    import { USERPROFILES } from "@/graphql/user/queries";
    import { CUSTOMERS, CONTACTSFULL, LOCATIONS } from "@/graphql/customer/queries";
    import { COMPANIES } from "@/graphql/company/queries";
    import { ACCOMMODATIONS } from "@/graphql/accommodation/queries";
    import { RESOURCES } from "@/graphql/resource/queries";
    // import { USERPROFILES } from "@/graphql/user/queries";
    import ScheduleList from '@/components/schedule/ScheduleList'
    import ResourceScheduleList from '@/components/schedule/ResourceScheduleList'
    import Pending from '@/components/notifications/Pending'
    import moment from 'moment';

    export default {
        name: 'UserProfileInfoDetails',
        components: { ScheduleList, ResourceScheduleList, Pending },
        props: {
        	userProfileSrc:{
        		type: Object,
        		default() {
                    return null
                },
        	},
            iconcolor:{
                type: String,
                default: null
            },
            customContent: {
                type: [String, Boolean],
                default: false
            },
            size: {
                type: [Number, String],
                default: null
            },
            currentDate: {
                type: String,
                default: null
            },
            defaultTab: {
                type: String,
                default: null
            },
            scheduleScrollTo: {
                type: String,
                default: null
            },
            forceType: {
                type: String,
                default: null
            },
        },
        data(){
        	return {
                myProfile: window.myUserProfile,
                userProfile: this.userProfileSrc,
                tab: "profile",
                myDate: null,
                queryResult: 'userProfiles'
            }
        },
        mounted() {

            if (this.forceType == "Customer" || this.userProfileSrc.__typename == "Customer") {
                this.queryResult="customers"
                this.$apollo.queries.userProfiles.options.query = CUSTOMERS
                this.tab="contacts"
            }
            if ( this.forceType =="CustomerContact" || this.userProfileSrc.__typename=="CustomerContact"){
                this.queryResult="contacts"
                this.$apollo.queries.userProfiles.options.query = CONTACTSFULL
                this.tab="notes"
            }
            if ( this.forceType == "Company" || this.userProfileSrc.__typename=="Company"){
                this.queryResult="companies"
                this.$apollo.queries.userProfiles.options.query = COMPANIES
                this.tab="notes"
            }
            if (this.forceType == "CustomerLocation" || this.userProfileSrc.__typename =="CustomerLocation"){
                this.queryResult="locations"
                this.$apollo.queries.userProfiles.options.query = LOCATIONS
                this.tab="notes"
            }
            if (this.forceType == "Accommodation" || this.userProfileSrc.__typename =="Accommodation"){
                this.queryResult="accommodations"
                this.$apollo.queries.userProfiles.options.query = ACCOMMODATIONS
                this.tab="accommodations"
            }
            if (this.forceType == "Resource" || this.userProfileSrc.__typename =="Resource"){
                this.queryResult="resources"
                this.$apollo.queries.userProfiles.options.query = RESOURCES
                this.tab="resources"
            }
            if(this.defaultTab) this.tab="schedule"

            // if(this.userProfileSrc) this.userProfile=this.userProfileSrc
            this.myDate=this.currentDate;
            if(!this.myDate) this.myDate = moment().format('YYYY-MM-DD');
        },
        computed: {
            companyInfo(){
                // if(!this.userProfile.company && !this.userProfile.customer ) return null;

                if(this.userProfile.company) return this.userProfile.company
                if(this.userProfile.customer) return this.userProfile.customer
                // if(this.userProfile.__typename=='Customer') return this.userProfile
                return null
            }
        },
        apollo: {
            userProfiles: {
                query: USERPROFILES,
                fetchPolicy: 'cache-and-network',	//cache-first, cache-and-network, cache-only, network-only, no-cache -> https://v4.apollo.vuejs.org/guide-composable/query.html#fetch-policy
                debounce: 200,
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: 'Oh Oh', caption: error.message});
                },
                variables() {
                    return {
                        ids: [ this.userProfileSrc.id ]
                    }
                },
                update(data){

                    if(data[this.queryResult] && data[this.queryResult].data.length>0) this.userProfile=data[this.queryResult].data[0]
                    // this.$emit('update-proxy')
                    return data
                }
            }
        }
        //watch: {},
        //methods: {},
    }
</script>
<style lang="scss">
    .-userprofile-info {
        
        .avatar-row {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-bottom: 15px;

            & .-title {
                font-size: 10px;
                font-weight: 400;
            }
        }


        &__toggle {
            font-size: 1.1em;
            color: $color-0;
            margin-top: -1px;
        }

        &__wrap {
            background-color: $color-0-lightest;
            padding: 20px;
            min-width: 450px;
            max-width: 450px;
            position: relative;
            @include media("<md") {
                min-width: 300px;
            }
        }

        & .-button-close {
            position: absolute;
            top: 6px;
            right: 6px;
        }

        .-row-info {
            display: flex;
            flex-direction: row;
            font-size: 10px;
            flex-wrap: wrap;

            & .-col-info {
                min-width: 50%;
                flex-grow: 1;
                display: flex;
                flex-direction: row;

                .q-icon {
                    margin-top: -2px;
                }
                > .q-icon {
                    margin-top: 1px;
                }
            }
        }
        .c-extra-info {
            font-size: 10px;
            margin: 20px -20px -20px;

            & .c-schedule-list.c-scheduleV2{
                max-height: 500px;
                min-height: 500px;
                overflow-y: auto;
            }
            & .fixed-height {
                max-height: 500px;
                min-height: 500px;
            }

            & .c-pendings.c-notifications {
                position: relative;
                max-height: 500px;
                min-height: 500px;
                width: 100%;
                top: unset;
                left: unset;
                right: unset;
                bottom: unset;
                // margin-top: 0;
            }

            & .q-tab-panel {
                padding: 0px;
            }
            &__tabs, &__content {
                width: 100%;
            }

            & .q-tab__label {
                font-size: 10px;
            }

            &__content {
                background-color: $color-1-darkest;

                & .-col-info {
                    margin-bottom: 20px;
                    flex-direction: column;
                    max-width: 50%;
                    padding-right: 20px;
                    // margin-right: -20px;
                }

                & .-row-info {
                    padding: 20px 20px 0;    
                }

                & .-label {
                    font-size: 9px;
                    font-weight: 700;
                    color: $color-0;
                }
                & .-value {
                    font-size: 10px;
                    font-weight: 800;
                    color: $white;
                    display: flex;
                }

                & .-rating {
                    flex-grow: 1;
                    text-align: right;
                    padding: 0 10px;
                    &>div{
                        flex-wrap: nowrap;
                    }
                }
            }
        }
    }
</style>